import { DateTime } from '@ksyos/date-time';
import { SupportModel } from '@common/contexts/support/domain/models/supportModel';
import type { ModelOptionalOptions } from '../types/modelType';

export class OutpatientClinicPatient extends SupportModel {
    public birthDate: DateTime;
    public id: string;
    public nameFamily: string;
    public nameFamily2: string | null;
    public nameGiven: string | null;
    public nameInfix: string | null;
    public nameInfix2: string | null;
    public nameInitials: string | null;
    public nameUsual: string | null;

    constructor(
        options: ModelOptionalOptions<
            OutpatientClinicPatient,
            'nameFamily2' | 'nameGiven' | 'nameInfix' | 'nameInfix2' | 'nameInitials' | 'nameUsual'
        >
    ) {
        super();

        this.birthDate = DateTime.from(options.birthDate);
        this.id = options.id;
        this.nameFamily = options.nameFamily;
        this.nameFamily2 = options.nameFamily2 ?? null;
        this.nameGiven = options.nameGiven ?? null;
        this.nameInfix = options.nameInfix ?? null;
        this.nameInfix2 = options.nameInfix2 ?? null;
        this.nameInitials = options.nameInitials ?? null;
        this.nameUsual = options.nameUsual ?? null;
    }
}
